interface Props {
  courseTitle: string;
  subtitle?: string;
  /** zero-based current index, used for the progress fill */
  index: number;
  total: number;
  rightLabel: string;
  rightSub?: string;
}

export function QuizTopBar({
  courseTitle,
  subtitle,
  index,
  total,
  rightLabel,
  rightSub,
}: Props) {
  const pct = total > 0 ? ((index + 1) / total) * 100 : 0;
  return (
    <div className="quiz-topbar">
      <div className="quiz-topbar__side quiz-topbar__left">
        <strong>{courseTitle}</strong>
        {subtitle && <span>{subtitle}</span>}
      </div>
      <div className="quiz-topbar__progress">
        <div className="quiz-topbar__track">
          <div className="quiz-topbar__fill" style={{ width: `${pct}%` }} />
        </div>
      </div>
      <div className="quiz-topbar__side quiz-topbar__right">
        <strong>{rightLabel}</strong>
        {rightSub && <span>{rightSub}</span>}
      </div>
    </div>
  );
}
